export default __webpack_public_path__ + "static/media/ki.92b18775.svg";